export default __webpack_public_path__ + "static/ODPRTI_V_SVET_ZNANJA-1a807b8ae7d726201b0d15dfb84d61c1.png";